import { equivalenceAuthObject, storage } from "store";
import { SetterOrUpdater } from "recoil";

type ParamsT = {
  auth: ReceivedAuthObjectT;
  setAuth: SetterOrUpdater<AuthDataT>;
};

export const onUserRes = (params: ParamsT) => {
  params.setAuth(equivalenceAuthObject(params.auth));
  storage.set(equivalenceAuthObject(params.auth));
};

export const onEditUserRes = (args: ParamsT) => onUserRes(args);
